import { serviceName } from '../resources/serviceConstants';
import { UPLOAD_CONFIG_DATES } from '../resources/endPoint';

export const fetchConfigUploadDates = (uploadCategory) => {
  // API call to fetch  upload configuration dates
  return {
    url: `${UPLOAD_CONFIG_DATES}?upload-category=${uploadCategory}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.INTEGRATION_MS,
  };
};

export const updateConfigUploadDates = (data) => {
  // API call to fetch update upload configuration dates
  return {
    url: `${UPLOAD_CONFIG_DATES}`,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.INTEGRATION_MS,
  };
};
